import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class ResponseHeadersService {

    constructor(
        public translateService: TranslateService,
        private _httpClient: HttpClient,
    ) {
    }


}
